<template lang="pug">
.diagnostico-socioambiental-em-lote-historico
    .diagnostico-socioambiental-em-lote-historico__info
        i.mdi.mdi-information
        p(v-html='formatarAviso()')
    .diagnostico-socioambiental-em-lote-historico__table
        el-table(
            :data='statusLista',
            v-loading='statusListaCarregando',
            height='320'
        )
            el-table-column(
                :label='$t("mensagens.diagnosticoSocioambiental.cargaEmLote.nomeArquivo")',
                prop='nome_arquivo'
            )
            el-table-column(
                :label='$t("mensagens.diagnosticoSocioambiental.cargaEmLote.dataHora")',
                prop='inicio_processamento',
                min-width='40'
            )
            el-table-column(
                :label='$t("mensagens.diagnosticoSocioambiental.cargaEmLote.status")',
                min-width='50',
                align='center'
            )
                template(#default='scope')
                    div(v-if='scope.row?.progress !== "-1"')
                        el-tag(v-if='scope.row?.labelProgress', size="mini") {{ scope.row?.labelProgress }}
                        el-progress(
                            :stroke-width='5',
                            :width='50',
                            :percentage='progressPorcentage(scope.row?.status_atualizacao_processamento, scope.row)',
                            :status='progressStatus(scope.row?.status_atualizacao_processamento)'
                        )
                    div(v-else)
                        i(class='el-icon-loading')
            el-table-column(label='', align='center', width='45')
                .template.d-flex.justify-content-center.tabela-gestao-icone(
                    slot-scope='scope'
                )
                    el-dropdown.action-button(trigger='click', v-if='scope.row?.status_atualizacao_processamento === "COMPLETED" || scope.row?.status_atualizacao_processamento !== "STOPPED"')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                v-if='statusExecutando(scope.row?.status_atualizacao_processamento)',
                                icon='el-icon-circle-close',
                                @click.native='cancelarProcessamento(scope.row?.id)'
                            ) {{ $t('mensagens.diagnosticoSocioambiental.cargaEmLote.cancelar') }}

                            el-dropdown-item(
                                v-if='scope.row?.status_atualizacao_processamento === "COMPLETED"',
                                @click.native='exportarRelatorio(scope.row?.id)'
                            )
                                i.mdi.mdi-file-download-outline
                                span {{ $t('mensagens.diagnosticoSocioambiental.cargaEmLote.exportarResultado') }}
</template>

<script>
import service from '@/services/DiagnosticoSocioambientalService';

export default {
    name: 'DiagnosticoSociambientalEmLoteHistorico',

    props: {
        statusLista: {
            type: Array,
            required: true
        },
        statusListaCarregando: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            timedebounce: null
        };
    },
    methods: {
        formatarAviso() {
            const aviso = this.$t(
                'mensagens.diagnosticoSocioambiental.cargaEmLote.aviso'
            );

            return aviso
                .replace(/"([^"]*)"/g, '<b>"$1"</b>')
                .replace(/\((.*?)\)/g, '<b>($1)</b>');
        },
        progressStatus(status) {
            switch (status) {
                case 'COMPLETED':
                    return 'success';
                case 'FAILED':
                case 'CANCELED':
                case 'STOPPED':
                    return 'exception';
                case 'UNKNOWN':
                case 'EXECUTING':
                case 'STARTED':
                case '':
                case null:
                case undefined:
                    return '';
                default:
                    return 'exception';
            }
        },
        progressPorcentage(status, row) {
            switch (status) {
                case 'COMPLETED':
                    return 100;
                case 'FAILED':
                case 'CANCELED':
                case 'STOPPED':
                    return 50;
                case 'EXECUTING':
                case 'STARTED':
                case 'UNKNOWN':
                case '':
                case null:
                case undefined:
                    return Number(row.progress);
                default:
                    return 50;
            }
        },
        progressColor(status) {
            switch (status) {
                case 'COMPLETED':
                    return '';
                case 'FAILED':
                case 'CANCELED':
                case 'STOPPED':
                    return '';
                case 'EXECUTING':
                case 'STARTED':
                case '':
                case null:
                case undefined:
                    return 'var(--primary)';
                default:
                    return '';
            }
        },
        statusExecutando(status) {
            return (
                status === 'EXECUTING' ||
                status === 'STARTED' ||
                status === '' ||
                status === null ||
                status === undefined
            );
        },
        formatarStatusProcessamento(status) {
            switch (status) {
                case 'COMPLETED':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.cargaEmLote.concluido'
                    );
                case 'FAILED':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.cargaEmLote.erro'
                    );
                case 'CANCELED':
                case 'STOPPED':
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.cargaEmLote.cancelado'
                    );
                case 'EXECUTING' || '' || null || undefined:
                    return this.$t(
                        'mensagens.diagnosticoSocioambiental.cargaEmLote.emProcessamento'
                    );
                default:
                    return status;
            }
        },
        async exportarRelatorio(id) {
            try {
                await service.resultadoProcessamentoEmLote(id);

                this.$notify.success({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.cargaEmLote.sucessoExportarProcessamento'
                    )
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.cargaEmLote.erroExportarProcessamento'
                    )
                });
            }
        },
        async cancelarProcessamento(id) {
            if (!id) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.cargaEmLote.erroCancelarProcessamento'
                    )
                });
                return;
            }
            try {
                await service.cancelarProcessamentoEmLote(id);

                this.$notify.success({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.cargaEmLote.processamentoCancelado'
                    )
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.cargaEmLote.erroCancelarProcessamento'
                    )
                });
            } finally {
                setTimeout(() => {
                    this.$emit('atualizarLista');
                }, 2000);
            }
        }
    }
};
</script>

<style lang="scss" slot-scope>
.diagnostico-socioambiental-em-lote-historico {
    display: flex;
    flex-direction: column;
    gap: 16px;

    &__table {
        margin: 2px 0;
    }

    &__info {
        display: flex;
        align-items: center;
        gap: 8px;
        background-color: #fdf7e8;
        border: 1px solid #faeac6;
        border-radius: 4px;
        padding: 16px 8px;
        word-break: normal;

        i {
            color: #d89c1a;
            font-size: 24px;
        }

        p {
            font-size: 14px;
            word-break: normal;
            color: var(--text-secondary);
            margin: 0;
        }
    }

    .el-icon-loading.loading {
        font-size: 14px !important;
        padding: 0;
        margin: 0 !important;
    }

    &__status {
        padding: 2px 0;
        display: flex;
        align-items: center;
        gap: 8px;

        span {
            font-size: 14px;
            color: var(--text-secondary);
        }
    }

    .diagnostico-socioambiental-em-lote-historico__info {
        border-radius: 4px 4px 0px 0px;
    }
    .status-executando {
        color: #ffd700;
    }

    .diagnostico-socioambiental-em-lote-historico__status {
        justify-content: center;
    }

    .el-tag {
        color: var(--primary);
    }

    .el-progress-bar__inner {
        background-color: var(--primary);
    }
}
</style>
